/**
 * generateArQrUrl — Build a mobile-targeted URL that auto-launches AR.
 *
 * Takes the current page URL, adds `ar=auto`, and strips params that
 * are desktop/embed-only (`mode`, `controls`).
 * The resulting URL is encoded in the QR code shown in ArQrModal on desktop.
 *
 * When scanned on a mobile device the app will load normally and, after
 * the 3D scene is ready, automatically open the AR modal.
 */

const STRIP_PARAMS = ['mode', 'controls'];

export function generateArQrUrl(): string {
  const url = new URL(window.location.href);

  STRIP_PARAMS.forEach((p) => url.searchParams.delete(p));

  // Ensure ar=auto is set (idempotent)
  url.searchParams.set('ar', 'auto');

  return url.toString();
}
